module.exports = __webpack_public_path__ + "static/media/history_bg.83515108.jpg";